import React from 'react'
import { Link } from 'react-router-dom'

import { User } from '../../user.types'
import styles from './ListOfUsers.module.scss'

interface Props {
  users: User[]
  className?: string
}

const ListOfUsers: React.FC<Props> = ({ users, className }) => {
  return (
    <div className={styles.list}>
      {users.map((user: User) => {
        const link = user.username
          ? user.username + '?id=' + user.id
          : user.first_name + ' ' + user.last_name + '?id=' + user.id
        console.log('link:', link)

        const userName = user.username ? user.username : user.first_name + ' ' + user.last_name

        return (
          <Link to={link} key={user.id} className={styles['list-item']}>
            <img className={styles.img} src={user.photo_url} alt={userName} />

            <div>
              <p className={styles.userName}>{userName}</p>
              <p className={styles.nickName}>ID: {user.id}</p>
            </div>
          </Link>
        )
      })}
    </div>
  )
}

export default ListOfUsers
